import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppLocalStorage } from '../../@core/utils/local-storage.util';


@Injectable({
  providedIn: 'root',
})
export class TownhallAdminGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    const profileDetails: any = AppLocalStorage.get(
      'PROFILE_DATA',
      'PROFILE_DATA'
    );

    const hasAdminAccess = profileDetails?.hasTownHallAccess === true;

    if (hasAdminAccess) {
      return true;
    }

    // ❌ No access → redirect
    this.router.navigate(['/townhall']); // or '/unauthorized'
    return false;
  }
}
